export default __webpack_public_path__ + "static/media/Megosu-Animation-Kartent.2fef7c48.mp4";